import {useRef} from "react";
import {fetchArticle} from "@/features/article/api/articleApi";

export const useCategory = ({source, currentCategoryId}) => {
    const isLoading = useRef(false);

    const changeCategory = (categoryId) => {
        if (isLoading.current || currentCategoryId === categoryId) return;
        isLoading.current = true;

        fetchArticle(source,{
            categoryId,
            page: 1,
            perPage: 12,
        },{
            onFinish: () => {
                isLoading.current = false;
            }
        });
    };

    return {changeCategory};
};
